import { Filter } from "../../../core/_shared/models/filter.model";
import { DbLotteryFilter } from "./db-lottery-filter";
import { getTreeNoValidDataSourceError } from '@angular/cdk/tree';
import { DbListBase } from './db-list-base';
import { ICollectionReference } from '../database-cast/IDatabase';



export class DbLotteryFilters extends DbListBase<Filter>{

    
   // private _collection: ICollectionReference;

    constructor(collection: ICollectionReference) {
        super(collection)
    }

    
  
    public add(value: Filter): Promise<Filter> {
        let promise = new Promise<Filter>((resolve, reject) => {
            this._collection.add((Object.assign({}, value)))
                .then(docReference => {

                    resolve(value);
                }).
                catch(error => {
                    reject(error);

                });
        });


        return promise;
    }

    
 public  getFilter(id: string): DbLotteryFilter {
    return new DbLotteryFilter(id,this._collection);
  }


}